import { createBrowserRouter } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/home/Home';
import InProgress from './pages/inProgress/InProgress';
import Constants from './utils/Constants';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: Constants.INPROGRESS_PAGE,
        element: <InProgress />,
      },
      {
        path: `${Constants.INPROGRESS_PAGE}/:id`,
        element: <InProgress />,
      },
    ],
  },
]);

export default router;
